import { render, staticRenderFns } from "./BpjstkDetail.vue?vue&type=template&id=fa6fd998"
import script from "./BpjstkDetail.vue?vue&type=script&lang=js"
export * from "./BpjstkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports